import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-center" }
const _hoisted_2 = { class: "text-h5 text-navy-700" }
const _hoisted_3 = { class: "row items-center q-pb-md" }
const _hoisted_4 = { class: "col-2" }
const _hoisted_5 = { class: "row items-center q-pb-sm" }
const _hoisted_6 = { class: "col-2" }

import { is } from "quasar"
import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"
import SfxInput from "src/components/input/SfxInput.vue"
import SfxSelect from "src/components/select/SfxSelect.vue"
import { ItemFilter } from "src/stores/filterStore"
import { ITEM_FILTERS_DEFAULT } from "src/util/constants/filters"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { ItemClass } from "src/util/types/dataModels/itemClass"
import { computed, PropType, ref, watch } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxFilterItems',
  props: /*#__PURE__*/_mergeModels({
  itemClassOptions: {
    type: Array as PropType<ItemClass[]>,
    required: true,
  },

  expandSection: {
    type: Boolean,
    default: false,
  },
}, {
    "itemFilters": { required: true },
    "itemFiltersModifiers": {},
  }),
  emits: ["update:itemFilters"],
  setup(__props) {

const itemFilters = _useModel<ItemFilter>(__props, "itemFilters")

const props = __props

//endregion

//region Variables

const { t } = useI18n()

const showFilterSection = ref(props.expandSection)
const hasFilters = ref(false)

const filterExpandIconClasses = computed(() =>
  showFilterSection.value ? "sfx-rotate-dropdown-icon__0" : "sfx-rotate-dropdown-icon__180"
)

const filterExpandSectionClasses = computed(() =>
  showFilterSection.value ? "sfx-filter-section" : ""
)

//endregion

//region Lifecycle
//endregion

//region Functions

function handleFiltersSection() {
  showFilterSection.value = !showFilterSection.value
}

function resetFilters() {
  itemFilters.value = structuredClone(ITEM_FILTERS_DEFAULT)
}

//endregion

//region Setup Code

watch(
  () => itemFilters,
  () => {
    hasFilters.value = !is.deepEqual(itemFilters.value, ITEM_FILTERS_DEFAULT)
  },
  { deep: true, immediate: true }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("sfxDialogFilter.items")), 1),
      _createVNode(SfxBtnIcon, {
        icon: _unref(Icons).CHEVRON_DOWN,
        class: _normalizeClass(filterExpandIconClasses.value),
        size: "24px",
        onClick: handleFiltersSection
      }, null, 8, ["icon", "class"]),
      _createVNode(_component_q_space),
      (hasFilters.value)
        ? (_openBlock(), _createBlock(SfxBtnIcon, {
            key: 0,
            icon: _unref(Icons).UNDO,
            size: "24px",
            onClick: resetFilters
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["text-subtitle1 text-fun-label-and-icon", filterExpandSectionClasses.value])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("sfxDialogFilter.item_class")), 1),
        _createVNode(SfxSelect, {
          class: "col-10",
          placeholder: _unref(t)('sfxDialogFilter.place_holder_item_class'),
          modelValue: itemFilters.value.itemClass,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((itemFilters.value.itemClass) = $event)),
          options: props.itemClassOptions,
          "option-label": (opt) => opt.designation,
          "option-value": (opt) => opt.id,
          loading: props.itemClassOptions?.length === 0,
          "emit-value": "",
          "map-options": "",
          "use-chips": "",
          multiple: ""
        }, null, 8, ["placeholder", "modelValue", "options", "option-label", "option-value", "loading"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)("sfxDialogFilter.designation")), 1),
        _createVNode(SfxInput, {
          class: "col-10",
          "place-holder": _unref(t)('sfxDialogFilter.place_holder_designation'),
          modelValue: itemFilters.value.designation,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((itemFilters.value.designation) = $event)),
          "hide-bottom-space": ""
        }, null, 8, ["place-holder", "modelValue"])
      ])
    ], 2)
  ], 64))
}
}

})